import React from 'react';
import {Link} from "react-router-dom";

const NavBar = () => {

    return (
        <nav className = "nav">
            <ul className="nav-content">
                <li><Link to = "/home" className = "link">Productos</Link></li>
                <li><Link to = "/search" className = "link">Buscador</Link></li>
                <li><Link to = "/add" className = "link">Agregar Producto</Link></li>
            </ul>
        </nav>
    );
}
 
export default NavBar;
